const INITIAL_STATE = {
  events: [],
  selectedCalendars: {},
};

const reducer = (state = INITIAL_STATE, action) => {
  if (action.type === 'EVENTS_UPDATED') {
    const { events } = action.payload;
    return { ...state, events };
  }
  if (action.type === 'EVENT_DELETED') {
    const { eventId } = action.payload;
    return {
      ...state,
      events: state.events.filter((e) => {
        if (e.id === eventId) {
          return false;
        }
        return true;
      }),
    };
  }
  if (action.type === 'EVENT_UPDATED') {
    const { event } = action.payload;
    return {
      ...state,
      events: state.events.map((e) => {
        if (e.id === event.id) {
          return event;
        }
        return e;
      }),
    };
  }
  if (action.type === 'EVENT_ADDED') {
    const { event } = action.payload;
    return {
      ...state,
      events: [...state.events, event],
    };
  }
  if (action.type === 'TOGGLE_CALENDAR') {
    const { id } = action.payload;
    return {
      ...state,
      selectedCalendars: {
        ...state.selectedCalendars,
        [id]: state.selectedCalendars[id] === false,
      },
    };
  }
  return state;
};

export default reducer;
